import {
  CFA_HELENE_ORG_EVENT_DEMO_KEY,
  DHS_REGION4_ORG_EVENT_DEMO_KEY,
  EPA_GULF_ORG_EVENT_DEMO_KEY,
  EQUINOR_GRANE_ORG_EVENT_DEMO_KEY,
  ONTARIO_GTA_ORG_EVENT_DEMO_KEY,
  CNIC_HAWAII_ORG_EVENT_DEMO_KEY,
  USCG_FOC_SE_ORG_EVENT_DEMO_KEY,
  type OrgEvent,
} from 'hooks/orgEvents/orgEventHooks';
import { isHardcodedMemphisThreatNotification } from '../NotificationsTab/memphisThreatNotification';
import { isHardcodedEpaGulfThreatNotification } from '../NotificationsTab/epaGulfThreatNotification';
import { isFacilityDemoNotificationId } from '../NotificationsTab/facilityDemoPack';
import { isHardcodedUscgFocSeThreatNotification } from '../NotificationsTab/uscgFocSoutheastThreatNotification';

export function isTropicalThresholdOrgEvent(
  event: OrgEvent | undefined | null
): boolean {
  if (!event) return false;
  if (event.creation_kind !== 'threshold') return false;
  const type = (event.type || '').toLowerCase();
  const demoKey = event.demo_key || '';
  return (
    type.includes('tropical') ||
    demoKey.startsWith('tropical:') ||
    demoKey === CFA_HELENE_ORG_EVENT_DEMO_KEY ||
    demoKey === EPA_GULF_ORG_EVENT_DEMO_KEY ||
    demoKey === DHS_REGION4_ORG_EVENT_DEMO_KEY ||
    demoKey === EQUINOR_GRANE_ORG_EVENT_DEMO_KEY ||
    demoKey === ONTARIO_GTA_ORG_EVENT_DEMO_KEY ||
    demoKey === CNIC_HAWAII_ORG_EVENT_DEMO_KEY ||
    demoKey === USCG_FOC_SE_ORG_EVENT_DEMO_KEY
  );
}

export function findTropicalOrgEventForNotification(
  sourceItemId: string | null | undefined,
  orgEvents: OrgEvent[]
): OrgEvent | undefined {
  if (!sourceItemId) return undefined;
  const event = orgEvents.find((e) => e.id === sourceItemId);
  return isTropicalThresholdOrgEvent(event) ? event : undefined;
}

/**
 * True for CFA Memphis / FOC Southeast demo ids or a real IOC alert linked to a
 * tropical threshold event.
 */
export function isTropicalThreatNotification(
  notification: {
    notificationId?: string | null;
    sourceItemId?: string | null;
  },
  orgEvents: OrgEvent[]
): boolean {
  if (
    isHardcodedMemphisThreatNotification(notification.notificationId) ||
    isHardcodedEpaGulfThreatNotification(notification.notificationId) ||
    isFacilityDemoNotificationId(notification.notificationId) ||
    isHardcodedUscgFocSeThreatNotification(notification.notificationId)
  ) {
    return true;
  }
  return !!findTropicalOrgEventForNotification(
    notification.sourceItemId,
    orgEvents
  );
}
